import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..';
import {
  Modalitapagamento_table_interface,
  Rubrica_table_interface,
} from '@bludata/common-interfaces';
import { Oculisti_table_interface } from '@bludata/common-interfaces';
import { Laboratorioest_table_interface } from '@bludata/common-interfaces';
import { Vettori_table_interface } from '@bludata/common-interfaces';
import { ClientiIngrosso_table_interface } from '@bludata/common-interfaces';
import { IndirizziSpedizione_table_interface } from '@bludata/common-interfaces';
import { Tipopagamento_table_interface } from '@bludata/common-interfaces';
import { Fornitor_table_interface } from '@bludata/common-interfaces';
import { Agente_table_interface } from '@bludata/common-interfaces';
import { Marchio_table_interface } from '@bludata/common-interfaces';
import { Linea_table_interface } from '@bludata/common-interfaces';
import { Fornitorecodice_table_interface } from '@bludata/common-interfaces';
import { IstitutiDiCredito_table_interface } from '@bludata/common-interfaces';
import { Categoria_table_interface } from '@bludata/common-interfaces';
import { Titolo_table_interface } from '@bludata/common-interfaces';

export interface FormSliceState {
  oculisti: {
    openForm?: 'new' | 'update' | 'info';
    item?: Oculisti_table_interface;
  };
  rubrica: {
    openForm?: 'new' | 'update' | 'info';
    item?: Rubrica_table_interface;
  };
  laboratoriesterni: {
    openForm?: 'new' | 'update' | 'info';
    item?: Laboratorioest_table_interface;
  };
  istitutidicredito: {
    openForm?: 'new' | 'update' | 'info';
    item?: IstitutiDiCredito_table_interface;
  };
  categoria: {
    openForm?: 'new' | 'update' | 'info';
    item?: Categoria_table_interface;
  };
  titoli: {
    openForm?: 'new' | 'update' | 'info';
    item?: Titolo_table_interface;
  };
  vettori: {
    openForm?: 'new' | 'update' | 'info';
    item?: Vettori_table_interface;
  };
  modalitapagamento: {
    openForm?: 'new' | 'update' | 'info';
    item?: Tipopagamento_table_interface;
  };
  tipopagamento: {
    openForm?: 'new' | 'update' | 'info';
    item?: Modalitapagamento_table_interface;
  };
  fornitori: {
    openForm?: 'new' | 'update' | 'info';
    item?: Fornitor_table_interface;
  };
  fornitoreCodice: {
    openForm?: 'new' | 'update' | 'info';
    item?: Fornitorecodice_table_interface;
  };
  indirizziSpedizione: {
    openForm?: 'new' | 'update' | 'info';
    item?: IndirizziSpedizione_table_interface;
  };
  agenti: {
    openForm?: 'new' | 'update' | 'info';
    item?: Agente_table_interface;
  };
  marchi: {
    openForm?: 'new' | 'update' | 'info';
    item?: Marchio_table_interface;
  };
  linee: {
    openForm?: 'new' | 'update' | 'info';
    item?: Linea_table_interface;
  };
  clientiIngrosso: {
    openForm?: 'new' | 'update' | 'info';
    item?: ClientiIngrosso_table_interface;
    indirizzoConsegnaOpenForm?: 'new' | 'update' | 'info';
    indirizzoConsegnaItem?: IndirizziSpedizione_table_interface;

    indirizziConsegna: IndirizziSpedizione_table_interface[];
    indirizziConsegnaUpdate: IndirizziSpedizione_table_interface[];
    indirizziConsegnaDelete: IndirizziSpedizione_table_interface[];
  };
}

const initialState: FormSliceState = {
  titoli: {},
  oculisti: {},
  rubrica: {},
  laboratoriesterni: {},
  istitutidicredito: {},
  categoria: {},
  vettori: {},
  modalitapagamento: {},
  tipopagamento: {},
  fornitori: {},
  fornitoreCodice: {},
  indirizziSpedizione: {},
  agenti: {},
  marchi: {},
  linee: {},
  clientiIngrosso: {
    indirizziConsegna: [],
    indirizziConsegnaUpdate: [],
    indirizziConsegnaDelete: [],
  },
};

const ArchiviSlice = createSlice({
  name: 'archivi',
  initialState,
  reducers: {
    resetFormValues(
      state: FormSliceState,
      action: PayloadAction<keyof FormSliceState>,
    ) {
      return { ...state, [action.payload]: {} };
    },
    setOculistiItem(
      state: FormSliceState,
      action: PayloadAction<Oculisti_table_interface | undefined>,
    ) {
      state.oculisti.item = action.payload;
    },
    setOculistiOpenForm(
      state: FormSliceState,
      action: PayloadAction<'new' | 'update' | 'info' | undefined>,
    ) {
      state.oculisti.openForm = action.payload;
    },
    setRubricaItem(
      state: FormSliceState,
      action: PayloadAction<Rubrica_table_interface | undefined>,
    ) {
      state.rubrica.item = action.payload;
    },
    setRubricaOpenForm(
      state: FormSliceState,
      action: PayloadAction<'new' | 'update' | 'info' | undefined>,
    ) {
      state.rubrica.openForm = action.payload;
    },
    setClientiIngrossoItem(
      state: FormSliceState,
      action: PayloadAction<ClientiIngrosso_table_interface | undefined>,
    ) {
      state.clientiIngrosso.item = action.payload;
    },
    setClientiIngrossoOpenForm(
      state: FormSliceState,
      action: PayloadAction<'new' | 'update' | 'info' | undefined>,
    ) {
      state.clientiIngrosso.openForm = action.payload;
    },
    setIndirizzoConsegnaItem(
      state: FormSliceState,
      action: PayloadAction<IndirizziSpedizione_table_interface | undefined>,
    ) {
      state.clientiIngrosso.indirizzoConsegnaItem = action.payload;
    },
    setIndirizziConsegna(
      state: FormSliceState,
      action: PayloadAction<IndirizziSpedizione_table_interface[]>,
    ) {
      state.clientiIngrosso.indirizziConsegna = action.payload;
    },
    setIndirizziConsegnaUpdate(
      state: FormSliceState,
      action: PayloadAction<IndirizziSpedizione_table_interface[]>,
    ) {
      state.clientiIngrosso.indirizziConsegnaUpdate = action.payload;
    },
    setIndirizzoConsegnaDelete(
      state: FormSliceState,
      action: PayloadAction<IndirizziSpedizione_table_interface[]>,
    ) {
      state.clientiIngrosso.indirizziConsegnaDelete = action.payload;
    },
    setIndirizzoConsegnaOpenForm(
      state: FormSliceState,
      action: PayloadAction<'new' | 'update' | 'info' | undefined>,
    ) {
      state.clientiIngrosso.indirizzoConsegnaOpenForm = action.payload;
    },
    setLaboratoriEsterniForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Laboratorioest_table_interface;
      }>,
    ) {
      state.laboratoriesterni = action.payload;
    },
    setIstitutiDiCreditoForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: IstitutiDiCredito_table_interface;
      }>,
    ) {
      state.istitutidicredito = action.payload;
    },
    setVettoriForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Vettori_table_interface;
      }>,
    ) {
      state.vettori = action.payload;
    },
    setModalitaPagamentoForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Tipopagamento_table_interface;
      }>,
    ) {
      state.modalitapagamento = action.payload;
    },
    setTipopagamentoForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Modalitapagamento_table_interface;
      }>,
    ) {
      state.tipopagamento = action.payload;
    },
    setFornitoriForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Fornitor_table_interface;
      }>,
    ) {
      state.fornitori = action.payload;
    },
    setFornitoreCodiceForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Fornitorecodice_table_interface;
      }>,
    ) {
      state.fornitoreCodice = action.payload;
    },
    setIndirizziSpedizioneForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: IndirizziSpedizione_table_interface;
      }>,
    ) {
      state.indirizziSpedizione = action.payload;
    },
    setAgentiForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Agente_table_interface;
      }>,
    ) {
      state.agenti = action.payload;
    },
    setMarchiForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Marchio_table_interface;
      }>,
    ) {
      state.marchi = action.payload;
    },
    setLineeForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Linea_table_interface;
      }>,
    ) {
      state.linee = action.payload;
    },
    setCategoriaForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Categoria_table_interface;
      }>,
    ) {
      state.categoria = action.payload;
    },
    setTitoliForm(
      state: FormSliceState,
      action: PayloadAction<{
        openForm?: 'new' | 'update' | 'info';
        item?: Titolo_table_interface;
      }>,
    ) {
      state.titoli = action.payload;
    },
  },
});

export const {
  resetFormValues,
  setOculistiItem,
  setOculistiOpenForm,
  setRubricaItem,
  setLaboratoriEsterniForm,
  setIstitutiDiCreditoForm,
  setCategoriaForm,
  setTitoliForm,
  setClientiIngrossoItem,
  setClientiIngrossoOpenForm,
  setRubricaOpenForm,
  setVettoriForm,
  setModalitaPagamentoForm,
  setTipopagamentoForm,
  setIndirizzoConsegnaItem,
  setIndirizzoConsegnaOpenForm,
  setIndirizziConsegna,
  setIndirizziConsegnaUpdate,
  setIndirizzoConsegnaDelete,
  setFornitoriForm,
  setIndirizziSpedizioneForm,
  setAgentiForm,
  setMarchiForm,
  setLineeForm,
  setFornitoreCodiceForm,
} = ArchiviSlice.actions;

export const oculistiItem = (
  state: RootState,
): Oculisti_table_interface | undefined => state.archivi.oculisti?.item;

export const oculistiOpenForm = (
  state: RootState,
): 'new' | 'update' | 'info' | undefined => state.archivi.oculisti?.openForm;

export const rubricaItem = (
  state: RootState,
): Rubrica_table_interface | undefined => state.archivi.rubrica?.item;

export const rubricaOpenForm = (
  state: RootState,
): 'new' | 'update' | 'info' | undefined => state.archivi.rubrica?.openForm;

export const clientiIngrossoItem = (
  state: RootState,
): ClientiIngrosso_table_interface | undefined =>
  state.archivi.clientiIngrosso?.item;

export const clientiIngrossoOpenForm = (
  state: RootState,
): 'new' | 'update' | 'info' | undefined =>
  state.archivi.clientiIngrosso?.openForm;

export const clienteIngrosso = (state: RootState): any | undefined =>
  state.archivi.clientiIngrosso;

export default ArchiviSlice.reducer;
